import {
  getGoogleFontQuery,
  getGoogleFontUrl,
} from "chameleon/lib/helpers/google-font-url";
import { sharedThemeValues } from "chameleon/lib/theme/theme-data";

type LoadFontProps = {
  font?: string;
};

export const loadFont = ({ font }: LoadFontProps) => {
  if (
    !font ||
    font === sharedThemeValues.typography.fontFamily ||
    getGoogleFontQuery(font) === ""
  )
    return;

  const fontTemplate = `@import url('${getGoogleFontUrl(font)}');`;
  const head = document.querySelector("head");
  const isFontLoaded = document.querySelector(`[data-font="${font}"]`);

  if (head && !isFontLoaded) {
    const style = document.createElement("style");
    style.dataset.font = font;
    style.innerHTML = fontTemplate;
    head.appendChild(style);
  }
};
